<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->

<form [formGroup]="formGroup" class="print-settings-box">
	<div class="plan-print-settings-grid">
		<!-- Orientation (3 col) -->
		<mat-form-field class="grid-col-3">
			<mat-label>{{ appStrings.PLAN_PRINT_SETTINGS_ORIENTATION_LABEL }}</mat-label>
			<mat-select formControlName="orientation" automationId="orientation">
				<mat-option *ngFor="let option of orientationOptions" [value]="option.value">
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<!-- Page Size (3 col) -->
		<mat-form-field class="grid-col-3">
			<mat-label>Page Size</mat-label>
			<mat-select formControlName="pageSize">
				<mat-option *ngFor="let option of pageSizeOptions" [value]="option.key">
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<!-- Width (3 cols) -->
		<mat-form-field class="grid-col-3">
			<mat-label>Width</mat-label>
			<input matInput type="number" formControlName="width" />
			<mat-error *ngIf="formGroup.controls.width.hasError('required')">
				{{ appStrings.GENERAL_REQUIRED_FIELD }}
			</mat-error>
			<mat-error *ngIf="formGroup.controls.width.hasError('min')">
				{{ getInvalidMinWidthMessage() }}
			</mat-error>
		</mat-form-field>

		<!-- Height (3 cols) -->
		<mat-form-field class="grid-col-3">
			<mat-label>Height</mat-label>
			<input matInput type="number" formControlName="height" />
			<mat-error *ngIf="formGroup.controls.height.hasError('required')">
				{{ appStrings.GENERAL_REQUIRED_FIELD }}
			</mat-error>
			<mat-error *ngIf="formGroup.controls.height.hasError('min')">
				{{ getInvalidMinHeightMessage() }}
			</mat-error>
		</mat-form-field>

		<!-- Units (3 cols) -->
		<mat-form-field class="grid-col-3">
			<mat-label>{{ appStrings.PLAN_PRINT_SETTINGS_UNITS_LABEL }}</mat-label>
			<mat-select formControlName="units" automationId="units">
				<mat-option *ngFor="let option of unitsOptions" [value]="option.value">
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<!-- Text Size (2 cols) -->
		<mat-form-field class="grid-col-2">
			<mat-label>{{ appStrings.PLAN_PRINT_SETTINGS_TEXT_SIZE_LABEL }}</mat-label>
			<mat-select formControlName="textSize" automationId="textSize">
				<mat-option *ngFor="let option of textSizeOptions" [value]="option.value">
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<!-- DPI (1 col) -->
		<mat-form-field class="grid-col-1">
			<mat-label>{{ appStrings.PLAN_PRINT_SETTINGS_DPI_LABEL }}</mat-label>
			<mat-select formControlName="dpi" automationId="dpi">
				<mat-option *ngFor="let option of dpiOptions" [value]="option.value">
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<!-- Role Legend (3 cols) -->
		<mat-form-field class="grid-col-3">
			<mat-label>{{ appStrings.PLAN_PRINT_SETTINGS_ROLE_LEGEND_LABEL }}</mat-label>
			<mat-select formControlName="roleLegend" automationId="roleLegend">
				<mat-option *ngFor="let option of roleLegendOptions" [value]="option.value">
					{{ option.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<!-- Print Button -->
	<div class="plan-print-footer">
		<mat-divider></mat-divider>
		<button
			mat-raised-button
			color="primary"
			type="button"
			class="print-button-action"
			(click)="onPrintClick()"
		>
			<mat-icon>print</mat-icon>
			{{ appStrings.PLAN_PRINT_ACTION }}
		</button>
	</div>
</form>
<!-- Loading state -->
<ng-template [loadingBlocker]="isPrinting$ | async" [displayGlobally]="true"></ng-template>
